import { Fragment, useCallback, useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { ScreenReaderAnnouncer } from 'marketplace-ui-common/components/accessibility/ScreenReaderAnnouncer';
import { useReviewContext } from './context/ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ReviewWizardSubmitSection({
  buttonProps,
  showLegalCheckbox = true
}) {
  const {
    onClick
  } = buttonProps;
  const {
    customValidationErrors,
    validationErrors
  } = useReviewContext();
  const [checkedLegalDisclaimer, setCheckedLegalDisclaimer] = useState(false);
  const [showLegalTooltip, setShowLegalTooltip] = useState(false);
  const handleSubmitClick = useCallback(e => {
    if (showLegalCheckbox && !checkedLegalDisclaimer) {
      setShowLegalTooltip(true);
    } else if (onClick) {
      onClick(e);
    }
  }, [checkedLegalDisclaimer, onClick, showLegalCheckbox]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [showLegalCheckbox && /*#__PURE__*/_jsx(ScreenReaderAnnouncer, {
      announcedText: showLegalTooltip ? unescapedText('trellisEcosystem.reviews.legalTooltip') : '',
      use: "assertive"
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "end",
      children: [showLegalCheckbox && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(View, {
          id: "disclaimer-text",
          marginInlineEnd: "200",
          as: "span",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            elements: {
              Link
            },
            message: "trellisEcosystem.reviews.legal_jsx",
            options: {
              href: 'https://legal.hubspot.com/review-guidelines',
              external: true
            }
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          open: showLegalTooltip,
          title: unescapedText('trellisEcosystem.reviews.legalTooltip'),
          children: /*#__PURE__*/_jsx(Checkbox, {
            "aria-labelledby": "disclaimer-text",
            checked: checkedLegalDisclaimer,
            onChange: ({
              target: {
                checked
              }
            }) => {
              setShowLegalTooltip(false);
              setCheckedLegalDisclaimer(checked);
            },
            marginInlineEnd: "700"
          })
        })]
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: customValidationErrors[0],
        children: /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
          disabled: validationErrors.length > 0 || customValidationErrors.length > 0 || !checkedLegalDisclaimer,
          onClick: handleSubmitClick
        }))
      })]
    })]
  });
}